/**
 * @description Get image substitutes in all available formats
 * @param {string} imageSrc - Image source
 * @param {object} imageFormats - Image formats
 * @returns {Array<{format: string, src: string}>} Image substitutes coming from product endpoint
 * @example
 * getImgSubstitutes('https://example.com/image.jpg', { 'https://example.com/image': ['webp', 'png'] })
 * // returns [
 * //   { format: 'webp', src: 'https://example.com/image.webp' },
 * //   { format: 'png', src: 'https://example.com/image.png' },
 * // ]
 */
export const createImgSubstitutesGetter = (imageFormats) => (
  imageSrc = 'http://assets.webshop.nl/eandb/ean/images/5df3ddc845d41775052115291e124ac2.300x300.jpeg'
) => {
  const originalExtension = imageSrc.match(/\.[^.]+$/)[0];
  const originalSize = imageSrc.match(/\.(\d+x\d+|thumb)/i)[0] || '';
  // img src with file and size extensions removed
  const imgSrcWithoutExtensions = imageSrc.replace(originalExtension, '').replace(originalSize, '');
  const availableFormats = imageFormats?.[imgSrcWithoutExtensions] || [];

  return availableFormats.reduce((acc, format) => {
    const constructedSrc = `${imgSrcWithoutExtensions}${originalSize}.${format}`;
    if (constructedSrc === imageSrc) {
      return acc;
    }
    return [
      ...acc,
      {
        format,
        src: constructedSrc,
      },
    ];
  }, []);
};
